module.exports = "<div>\n    {{$state.current.displayTab || $state.current.display}}\n</div>\n"